import React from 'react';
import { Card } from 'antd';
import { SkBar } from './_primitives';

const OffersHeader = () => (
  <div className="flex flex-col gap-2 mb-4 sm:mb-6">
    <SkBar h="h-7" w="w-56" className="max-w-full" />
    <SkBar h="h-3" w="w-96" className="max-w-full" />
  </div>
);

const StatCard = () => (
  <Card className="shadow-sm" styles={{ body: { padding: 20 } }}>
    <div className="flex flex-col gap-3">
      <SkBar h="h-3" w="w-28" />
      <div className="flex items-center gap-2">
        <div className="w-5 h-5 rounded bg-gray-200 animate-pulse flex-shrink-0" />
        <SkBar h="h-6" w="w-12" />
      </div>
    </div>
  </Card>
);

const FilterBarCard = () => (
  <Card className="shadow-sm mb-4" styles={{ body: { padding: 16 } }}>
    <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
      <SkBar h="h-10" w="w-full sm:flex-1 sm:max-w-xs" className="rounded-md" />
      <SkBar h="h-10" w="w-full sm:w-40" className="rounded-md" />
      <SkBar h="h-10" w="w-full sm:w-44" className="rounded-md" />
      <SkBar h="h-10" w="w-full sm:w-32" className="rounded-md" />
      <SkBar h="h-10" w="w-full sm:w-32" className="rounded-md sm:ml-auto" />
    </div>
  </Card>
);

const OFFER_COLS = ['w-20', 'w-12', 'w-12', 'w-16', 'w-16', 'w-20', 'w-12', 'w-14', 'w-14'];

const OfferRow = () => (
  <div className="grid grid-cols-[1.5fr_1fr_1fr_1fr_1fr_1.3fr_0.8fr_1fr_1fr] gap-3 py-4 border-b border-gray-100 last:border-b-0 items-center">
    {/* Offer Name + subtitle + status dot */}
    <div className="flex flex-col gap-1.5 min-w-0">
      <SkBar h="h-3" w="w-24" />
      <SkBar h="h-2" w="w-20" />
      <div className="flex items-center gap-1.5">
        <div className="w-2 h-2 rounded-full bg-gray-200 animate-pulse" />
        <SkBar h="h-2" w="w-12" />
      </div>
    </div>
    {/* Code pill */}
    <SkBar h="h-6" w="w-16" className="rounded-md" />
    {/* Type pill */}
    <SkBar h="h-6" w="w-20" className="rounded-md" />
    {/* Audience pill */}
    <SkBar h="h-5" w="w-10" className="rounded-md" />
    {/* Discount */}
    <SkBar h="h-3" w="w-12" />
    {/* Valid Period (two lines + expired pill) */}
    <div className="flex flex-col gap-1.5 min-w-0">
      <SkBar h="h-3" w="w-24" />
      <SkBar h="h-2" w="w-20" />
      <SkBar h="h-5" w="w-14" className="rounded-md" />
    </div>
    {/* Usage */}
    <SkBar h="h-3" w="w-10" />
    {/* Status pill */}
    <SkBar h="h-6" w="w-16" className="rounded-md" />
    {/* Actions */}
    <div className="flex items-center gap-2 justify-end">
      <SkBar h="h-8" w="w-8" className="rounded-md" />
      <SkBar h="h-8" w="w-8" className="rounded-md" />
    </div>
  </div>
);

const TablePagination = () => (
  <div className="flex items-center justify-end gap-2 mt-4 pt-3">
    <SkBar h="h-8" w="w-8" className="rounded-md" />
    <SkBar h="h-8" w="w-8" className="rounded-md" />
    <SkBar h="h-8" w="w-8" className="rounded-md" />
  </div>
);

/**
 * OffersPageLoader — matches Offer Management layout:
 *  header (title + subtitle) · 4 stat cards · filter bar card
 *  (search · type · audience · status · create button) · offers table · pagination.
 */
const OffersPageLoader = () => (
  <div className="w-full p-3 sm:p-4 md:p-6">
    <OffersHeader />

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
      {Array.from({ length: 4 }).map((_, i) => (
        <StatCard key={i} />
      ))}
    </div>

    <FilterBarCard />

    <Card className="shadow-sm" styles={{ body: { padding: 20 } }}>
      <div className="overflow-x-auto">
        <div className="min-w-[1100px]">
          <div className="grid grid-cols-[1.5fr_1fr_1fr_1fr_1fr_1.3fr_0.8fr_1fr_1fr] gap-3 pb-3 border-b border-gray-200">
            {OFFER_COLS.map((w, i) => (
              <SkBar
                key={i}
                h="h-3"
                w={w}
                className={i === OFFER_COLS.length - 1 ? 'justify-self-end' : ''}
              />
            ))}
          </div>
          {Array.from({ length: 6 }).map((_, i) => (
            <OfferRow key={i} />
          ))}
        </div>
      </div>
      <TablePagination />
    </Card>
  </div>
);

export default OffersPageLoader;
